<template>
  <v-container fluid>
    <h1>{{ $t("nuestrosParking") }}</h1>
    <v-card
      class="mt-5 mx-auto"
      fluid
      v-for="par in parkings"
      :key="par['nom']"
    >
      <v-img
        v-if="par['nom'] === 'Parking Luna de Granada'"
        style="width: 100%;height: 500px;"
        contain

        src="@/assets/portadac2.jpg"
      ></v-img>
      <v-img
        v-else-if="par['nom'] === 'Parking Luna centro'"
        style="width: 100%;height: 500px;"
        contain

        src="@/assets/portadac1.jpg"
      ></v-img>

      <v-card-title>{{ par["nom"] }} - {{ par["ciu"] }} </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="par['nom'] == 'Parking Luna de Granada'">
            <span >{{
              $t("contactoSB")
            }}</span><br ><br>
            <span >{{
              $t("contactoSB2")
            }}</span><br><br>
            <span >{{
              $t("contactoSB3")
            }}</span>
          </div>

          <div v-if="par['nom'] == 'Parking Luna centro'">
            <span 
              >{{ $t("contactoGV") }}<br
            /></span><br>
            <span >{{
              $t("contactoGVTurismo")
            }}</span>
          </div>


          <br />
          <span v-if="par['nom'] == 'Parking Luna centro'">
            <v-icon class="mb-1" dense>mdi-phone</v-icon>{{ par["tel"] }}</span
          >
          <span v-else-if="par['nom'] == 'Parking Luna de Granada'">
            <v-icon class="mb-1" dense>mdi-phone</v-icon
            >{{ par["tel"] }}</span
          >

          <br /><br />
          <span v-if="par['nom'] == 'Parking Luna de Granada'">
            <v-icon class="mb-1" dense>mdi-email</v-icon
            >{{ $t("correoParkingSanBernardo") }}</span
          >
          <span v-else-if="par['nom'] == 'Parking Luna centro'">
            <v-icon class="mb-1" dense>mdi-email</v-icon
            >{{ $t("correoParkingGranVia") }}</span
          >
          <span v-else>
            <v-icon class="mb-1" dense>mdi-email</v-icon
            >{{ $t("correoParkingUnio") }}</span
          >
          <br /><br />
          <span v-if="par['nom'] == 'Parking Luna centro'">
            <v-icon class="mb-1" dense>mdi-map-marker</v-icon
            ><a target="_blank" :href="linkComoLlegarParkingLunaCentro">{{
              $t("comollegar")
            }}</a>
          </span>
          <span v-else-if="par['nom'] == 'Parking Luna de Granada'">
            <v-icon class="mb-1" dense>mdi-map-marker</v-icon
            ><a target="_blank" :href="linkComoLlegarParkingLunaGranada">{{
              $t("comollegar")
            }}</a>
            </span>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/plugins/api";
export default {
  data() {
    return {
      parkings: [],
      mostrar: false,
      itemsBarcelona: [
        {
          id: 1,
          name: "servicios",
          children: [
            { id: 2, name: "servicioVideoVigilancia" },
            { id: 3, name: "pago" },
            { id: 4, name: "aseos" },
            { id: 5, name: "servicioPlazasMinusvalidos" },
            { id: 6, name: "ascensor" },
          ],
        },
      ],
      itemsMadrid: [
        {
          id: 1,
          name: "servicios",
          children: [
            { id: 2, name: "servicioVideoVigilancia" },
            { id: 3, name: "pago" },
            { id: 4, name: "servicioPlazasMinusvalidos" },
            { id: 5, name: "ascensor" },
            { id: 6, name: "aseos" },
          ],
        },
      ],
      itemsSanBer: [
        {
          id: 1,
          name: "servicios",
          children: [
            { id: 4, name: "servicioPlazasMinusvalidos" },
            { id: 5, name: "ascensor" },
          ],
        },
      ],
      linkComoLlegarParkingLunaCentro:
        "https://www.google.es/maps/place/Parking+Luna+Centro/@37.171194,-3.6017685,17z/data=!3m1!4b1!4m6!3m5!1s0xd71fdd5288ed97d:0x3cd525c728f6a4b5!8m2!3d37.1711898!4d-3.5991936!16s%2Fg%2F11sb6rty1c?hl=es&entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D",
        linkComoLlegarParkingLunaGranada:
        "https://www.google.es/maps/place/Parking+en+Granada+-+Parking+Luna+de+Granada/@37.1712149,-3.6094933,15z/data=!3m1!5s0xd71fc8d4455b6e7:0x7c909faefdd56afd!4m10!1m2!2m1!1sparking+luna+granada!3m6!1s0xd71fc8d7957a415:0x78aa0b0b5a566f01!8m2!3d37.176514!4d-3.6123517!15sChRwYXJraW5nIGx1bmEgZ3JhbmFkYZIBC3BhcmtpbmdfbG904AEA!16s%2Fg%2F11gd67p3jj?hl=es&entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D",
    };
  },
  methods: {
    obtenerTodosLosDatosParkings() {
      api.obtenerParkings().then((res) => {
        //console.log(res);
        this.parkings = res.data.parkings;
      });
    },
  },
  created() {
    this.idioma = window.localStorage.getItem("idioma");
    this.obtenerTodosLosDatosParkings();
  },
};
</script>

<style>
</style>